import { kamatiApi } from './kamatiApi';
export { kamatiApi };
export default kamatiApi;